<template>
  <div class="section">
    <!-- 认知能力 -->
    <div class="title-info">
      考察对人才未来工作效率和质量产生关键影响力的能力素质项，可参考预测人才工作效率。
    </div>
    <div class="bg-container-boxer">
      <div class="bg"></div>
      <table class="bg-container" cellpadding="1" cellspacing="0" style="margin-left:30px">
        <tr>
          <td>
            <behaviorBar :model="this.renzhi" />
          </td>
          <td style="vertical-align: top">
            <table class="table-content" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  style="
                    text-align: center;
                    color: #29bdb9;
                    height: 36px;
                    font-size: 18px;
                    font-weight: bold;
                  "
                >
                  指标内涵
                </td>
              </tr>
              <tr v-for="(item, index) in this.renzhi" :key="index">
                <td>{{ item.define }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import behaviorBar from "@/components/dataView/echarts/all/behaviorBar.vue";
export default {
  components: {
    behaviorBar,
  },
  props: ["renzhi"],
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {},
  watch: {},
  methods: {
    loadData() {},
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-image: url("../../../assets/images/all/bd2/ren1.png");
  background-size: contain;
  background-repeat: no-repeat;
  height: 1124px;
  overflow: hidden;
  .title-info {
    padding: 270px 0 0 0;
    font-size: 14px;
    text-align: center;
  }
  .table-info {
    padding-top: 0px;
  }
  .table-content {
    margin-top: -38px;
    font-size: 14px;
    text-align: left;
    margin-right: 35px;
    width: 280px;
    td {
      height: 70px;
    }
  }
  .bg-container {

    // padding: 60px auto 50px;
  }
  .bg-container-boxer{
    position:relative;
    width:760px;
    margin:55px auto 39px;
    .bg-container{
      position: relative;
      z-index: 2;
      top:0px;
      left: 0px;;
    }
    .bg{
      position:absolute;
      background:url("../../../assets/images/all/bd2/bg2.png");
      background-repeat: no-repeat;
      z-index:0;
      height:100%;
      width:100%;
      top:0px;
      left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/four/pageThree.vue